import { useSelector } from 'react-redux';
import { selectSearch } from '@client/catalog/redux/search/redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { CatalogSearchType } from 'b2b-common/core/catalog/Catalog.types';

export function useSearchData(): RemoteRecord<CatalogSearchType> {
  return useSelector(selectSearch);
}
